module.exports = __webpack_public_path__ + "static/media/SerifGoodOptimized.c32b067e.webp";